function loadGoogleAnalytics(measurementId) {
  if (!measurementId) return;
  // Inject gtag script
  const existing = document.querySelector(`script[src*="googletagmanager.com/gtag/js?id="]`);
  if (!existing) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(s);
  }

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', measurementId, { anonymize_ip: true });
}

export function initAnalytics() {
  const meta = document.querySelector('meta[name="ga-measurement-id"]');
  const id = meta && meta.getAttribute('content');
  if (!id) return;

  // Initialize on first load
  loadGoogleAnalytics(id);

  // Track Turbo pageviews
  document.addEventListener('turbo:load', function() {
    if (typeof window.gtag === 'function') {
      window.gtag('config', id, { page_path: window.location.pathname });
    } else if (window.dataLayer) {
      // In case gtag isn't present yet, push event manually
      window.dataLayer.push({
        event: 'page_view',
        page_path: window.location.pathname
      });
    }
  });
}


